// lib/graphql.js
import axios from "axios"

export const GRAPHQL_ENDPOINT =
    process.env.NEXT_PUBLIC_WP_GRAPHQL_ENDPOINT ||
    "https://site.figmawya.com/graphql"

// Query Document
export const HOME_FEED_QUERY = /* GraphQL */ `
  fragment AuthorFields on NodeWithAuthor {
    author {
      node {
        name
      }
    }
  }

  fragment FeaturedImageMedium on NodeWithFeaturedImage {
    featuredImage {
      node {
        sourceUrl(size: MEDIUM_LARGE)
      }
    }
  }

  fragment FeaturedImageThumbnail on NodeWithFeaturedImage {
    featuredImage {
      node {
        sourceUrl(size: THUMBNAIL)
      }
    }
  }

  fragment FeaturedImageLarge on NodeWithFeaturedImage {
    featuredImage {
      node {
        sourceUrl(size: LARGE)
      }
    }
  }

  query HomeFeed {
    designReviews(first: 6) {
      nodes {
        id: databaseId
        title
        date
        ...AuthorFields
        ...FeaturedImageMedium
      }
    }

    figtemps(first: 6) {
      nodes {
        id: figtempId
        title
        date
        ...AuthorFields
        ...FeaturedImageMedium
      }
    }


    figplgs(first: 6) {
      nodes {
        id: figplgId
        title
        date
        ...AuthorFields
        ...FeaturedImageMedium
      }
    }

    posts(first: 6) {
      nodes {
        id: postId
        title
        date
        ...AuthorFields
        ...FeaturedImageMedium
      }
    }

    jobs(first: 6) {
      nodes {
        id: jobId
        title
        date
        ...AuthorFields
        ...FeaturedImageMedium
      }
    }

    sessions(first: 4) {
      nodes {
        id: sessionId
        title
        date
        ...FeaturedImageMedium
      }
    }

    podcasts(first: 6) {
      nodes {
        id: podcastId
        title
        date
        ...FeaturedImageMedium
      }
    }

    challenges(first: 1) {
      nodes {
        challengeId
        title
        date
        acf {
          deadline
          difficulty
        }
        participants {
          displayName
          id
          acceptedAt
          status
          avatar
        }
        participantCount
      }
    }

    shortsAds(first: 5) {
      nodes {
        id
        title
        acfShorts {
          linkType
          shortAdLink
        }
        ...FeaturedImageLarge
      }
    }

    community(first: 20) {
      nodes {
        title
        id: communitySectionsId
        ...FeaturedImageThumbnail
      }
    }

    quotes(first: 1, where: { orderby: { field: DATE, order: DESC } }) {
      nodes {
        id: quoteId
        title
        date
        acfQuotes {
          authors: qAuthor {
            nodes {
              ... on QouteAuthor {
                name: title
                thumb: featuredImage {
                  node {
                    src: sourceUrl(size: THUMBNAIL)
                  }
                }
              }
            }
          }
        }
      }
    }

    speakers {
      nodes {
        title
        ...FeaturedImageThumbnail
      }
    }
  }
`

/**
 * Generic GraphQL request helper
 * - returns data
 * - throws an Error containing GraphQL errors if present
 */
export async function gqlRequest({
    query,
    variables,
    signal,
    headers,
} = {}) {
    if (!query) throw new Error("gqlRequest requires a query")

    const res = await axios.post(
        GRAPHQL_ENDPOINT,
        { query, variables },
        {
            signal,
            headers: {
                "Content-Type": "application/json",
                ...(headers || {}),
            },
        }
    )

    const payload = res?.data

    if (payload?.errors?.length) {
        const msg = payload.errors.map((e) => e.message).join(" | ")
        const err = new Error(msg)
        err.graphqlErrors = payload.errors
        throw err
    }

    return payload?.data
}